export const groupKinds = [{key: 'main', title: 'Основная'}, {key: 'itr', title: 'ИТР'}, {key: 'supply', title: 'Снабжение'}, {key: 'mechanics', title: 'Механики'}];

export function telegramGroupsRoot(card) {
    if (card.owner_type === 'object_group') return `/api/object-groups/${card.object_group_id}/telegram-groups`;
    if (card.preparation_id) return `/api/objects/preparations/${card.preparation_id}/telegram-groups`;
    return `/api/objects/unified/${card.building_id}/telegram-groups`;
}

export function objectMembershipId(object) {
    return Number(object.object_group && object.object_group.id || object.object_group_id) || null;
}

export function hasTelegramGroup(row) {
    return !!row.chat_id || ['queued', 'running', 'unknown'].includes(row.status);
}

export function telegramGroupStateText(status, chatId) {
    if (chatId && status === 'queued') return 'настройка ожидает продолжения';
    if (chatId && status === 'running') return 'настраивается состав и права';
    return {
        queued: 'ожидает создания',
        running: 'создаётся',
        failed: 'не удалось создать или привязать',
        unknown: 'результат неизвестен',
        warning: 'требует проверки'
    }[status] || status;
}

export function telegramGroupHref(chatId) {
    const id = String(chatId || '').trim();
    return /^-100\d+$/.test(id) ? `https://t.me/c/${id.slice(4)}/999999999` : null;
}
export function objectTelegramLinks(object) {
    const groups = object.telegram_groups || [];
    const main = object.common_chat_id && object.common_chat_id !== 'null'
        ? object.common_chat_id : (groups.find(group => group.kind === 'main') || {}).chat_id;
    const seen = new Set();
    const ordered = [{kind: 'main', chat_id: main}].concat(
        groupKinds.slice(1).map(kind => groups.find(group => group.kind === kind.key)).filter(Boolean),
        groups.filter(group => !groupKinds.some(kind => kind.key === group.kind)));
    return ordered.reduce((links, group) => {
        const href = telegramGroupHref(group.chat_id);
        if (!href || seen.has(href)) return links;
        seen.add(href);
        const kind = groupKinds.find(kind => kind.key === group.kind);
        links.push({href, title: kind ? kind.title : group.name || 'Дополнительная'});
        return links;
    }, []);
}
export const curatorNote = 'Необходимость создания дополнительных групп и состав их участников уточните у куратора объекта';
export function addParticipants(current, users) {
    const result = current.map(person => Object.assign({}, person));
    users.forEach(user => {
        if (!user || !user.user_id || user.active === false || user.isBot === true) return;
        const existing = result.find(person => Number(person.user_id) === Number(user.user_id));
        if (existing) { if (user.telegram_admin_required) existing.isAdmin = true; return; }
        result.push({user_id: Number(user.user_id), isAdmin: user.telegram_admin_required === true || !!(user.ChatGroups && user.ChatGroups.IsAdmin)});
    });
    return result;
}
export function additionalGroups(source = {}) {
    const result = {};
    groupKinds.slice(1).forEach(({key}) => {
        result[key] = Object.assign({enabled: false, initialized: false, participants: []}, source[key] || {});
    });
    return result;
}
export function groupName(kind, objectName, shared = false) {
    return `${kind === 'main' ? 'АДС —' : groupKinds.find(item => item.key === kind).title + (shared ? ' —' : ' -')} ${objectName}`;
}
export function initialParticipants(process = {}, additional = false) {
    return addParticipants([], [{user_id: process.main_staff_id}, {user_id: process.curator_id}]).map(person =>
        Object.assign({}, person, {isAdmin: additional && Number(person.user_id) === Number(process.curator_id)}));
}
export function invitationIssues(group, users = []) {
    const result = group.result || {};
    const name = id => {
        const saved = (result.missing_users || []).find(person => Number(person.user_id) === Number(id));
        const user = users.find(person => Number(person.user_id) === Number(id));
        return saved && saved.name || user && user.full_name || `Сотрудник #${id}`;
    };
    if (Array.isArray(result.invitation_results)) return result.invitation_results.filter(person =>
        person.status !== 'added' || person.is_admin && person.admin_status !== 'assigned').map(person =>
        Object.assign({}, person, {name: person.name || name(person.user_id)}));
    const missing = result.missing_user_ids || [];
    if (missing.length) return missing.map(id => ({user_id: id, name: name(id), status: 'failed', reason: 'not_added'}));
    // Old operations and interrupted creation may have no per-person result.
    return (group.participants || []).filter(person => !result.admin_warning || person.isAdmin).map(person => ({
        user_id: person.user_id, name: name(person.user_id), is_admin: person.isAdmin,
        status: result.admin_warning ? 'added' : 'unknown', reason: 'unconfirmed', admin_status: 'not_assigned'
    }));
}
export function invitationIssueText(person) {
    if (person.status === 'added') return 'Добавлен, но права администратора не подтверждены';
    if (person.status === 'unknown') return 'Добавление не подтверждено — проверьте состав группы';
    return {
        privacy: 'Не добавлен: настройки конфиденциальности Telegram',
        missing_phone: 'Не добавлен: у сотрудника не указан телефон',
        not_found: 'Не добавлен: Telegram-аккаунт не найден по телефону',
        lookup_failed: 'Не добавлен: не удалось найти Telegram-аккаунт',
        rate_limit: 'Не добавлен: Telegram ограничил частоту запросов. Попробуйте вручную позже',
        no_permission: 'Не добавлен: недостаточно прав в Telegram',
        capacity: 'Не добавлен: достигнут лимит Telegram на группы или участников',
        policy_unavailable: 'Не добавлен: не удалось подтвердить актуальную учётную запись и права в Аргусе',
        auth_required: 'Не добавлен: Telegram требует восстановления подключения',
        session_unavailable: 'Не добавлен: подключение Telegram недоступно'
    }[person.reason] || 'Не добавлен: Telegram не подтвердил добавление';
}
export function telegramIncidents(group, users = []) {
    if (Array.isArray(group.incidents)) return group.incidents;
    const issues = invitationIssues(group, users).map(person => Object.assign({key: `user:${person.user_id}`, type: 'user'}, person));
    if (!issues.length) issues.push({key: 'setup', type: 'setup', name: 'Проверка группы', message: group.result && group.result.message});
    return issues;
}
